import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'button-item',
  templateUrl: './button-item.component.html',
  styleUrls: ['./button-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonItemComponent implements OnInit {

  @Input('icon') icon: string | any[] = ['fa-solid','fa-gear']
  @Input('back') back: string;
  @Input('tooltip') tooltip: string;
  @Input('opacity') opacity: boolean;
  @Input('disable') disable = false;
  @Input('fabSize') fabSize: string | null = null;
  @Input() dndDraggable;

  constructor() { }

  ngOnInit() {
  }

}
